var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('ul',_vm._l((_vm.submenu),function(item,index){return _c('li',{key:index,class:`${item.class} ${
            _vm.$route.meta.module == item.url ? ' active' : ''
          }  ${item.disabled ? ' disabled' : ''}`,on:{"click":function($event){return _vm.$router.push(item.url)}}},[_c('div',{staticClass:"item",class:item.url ? '' : 'disable-click'},[_vm._v("\n          "+_vm._s(item.itemName)+"\n        ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }